import React, { useState } from "react";
import Card from "components/design-system/atoms/Card";
import { Form, Field, ErrorMessage } from "formik";
import { Button, styled, Box } from "@material-ui/core";
import Input from "components/design-system/atoms/Input";
import BodyLarge from "components/design-system/atoms/Typography/BodyLarge";
import Small from "components/design-system/atoms/Typography/Small";
import HelpTextCard from "components/design-system/molecules/HelpTextCard";
import HelpTextCardLastName from "components/design-system/molecules/HelpTextCardLastName";

const StyledForm = styled(Form)({
  display: "flex",
  flexDirection: "column",
});

const StyledInput = styled(Input)(({ theme }) => ({
  height: `${theme.spacing(7)}px`,
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.background.default,
  height: `${theme.spacing(6)}px`,
}));

const StyledFormErrorMessage = styled(Small)(({ theme }: any) => ({
  color: theme.palette.error.main,
  width: "100%",
  position: "absolute",
  bottom: theme.spacing(1),
  textAlign: "left",
}));

const LoginCard = () => {
  const [displayFileNumberHelperText, setDisplayFileNumberHelper] = useState(true);
  const [displayNameHelper, setDisplayNameHelper] = useState(false);
  return (
    <Card padding={3}>
      <Box marginBottom={3}>
        <BodyLarge>Veuillez renseigner votre numéro de dossier</BodyLarge>
      </Box>
      <StyledForm>
        <Box position="relative" display="flex" flexDirection="column" paddingBottom={3}>
          <Field
            as={StyledInput}
            name="file_number"
            label="Votre N° de dossier"
            variant="outlined"
            onFocus={() => setDisplayFileNumberHelper(true)}
            onBlur={() => setDisplayFileNumberHelper(false)}
          />
          <ErrorMessage name="file_number" component={StyledFormErrorMessage} />
        </Box>
        {displayFileNumberHelperText && (
          <Box marginBottom={3}>
            <HelpTextCard oneLineCentered={false}>
              Vous retrouverez votre numéro de dossier en haut de chaque email envoyé par Murfy
              <br />
              Exemple: 200001_200001
            </HelpTextCard>
          </Box>
        )}
        <Box position="relative" display="flex" flexDirection="column" paddingBottom={3}>
          <Field
            as={StyledInput}
            name="lastname"
            label="3 premières lettres de votre nom"
            variant="outlined"
            onFocus={() => setDisplayNameHelper(true)}
            onBlur={() => setDisplayNameHelper(false)}
          />
          <ErrorMessage name="lastname" component={StyledFormErrorMessage} />
        </Box>
        {displayNameHelper && (
          <Box marginBottom={3}>
            <HelpTextCardLastName />
          </Box>
        )}
        <StyledButton
          variant="contained"
          type="submit"
          onMouseDown={(e: React.MouseEvent<HTMLButtonElement>) => e.preventDefault()}
        >
          Continuer
        </StyledButton>
      </StyledForm>
    </Card>
  );
};

export default LoginCard;
